import dayjs from 'dayjs';
import React from 'react';
import { Badge } from 'reactstrap';

const fm = new Intl.NumberFormat("es-MX", {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
  });

const Columns = (print) => {
	let columns = [
		{
			id: 'tiempo',
			name: 'Tiempo de salida',
			center: true,
			selector: row => row?.time,
		},
		{
			id: 'unit',
			name: 'Unidad',
			center: true,
			selector: row => row?.unit?.number,
		},
		{
			id: 'No_salida',
			name: 'No salida',
			center: true,
			selector: row => row?.no,
		},
		{
			id: 'complete',
			name: 'Estado',
			center: true,
			selector: row => row.latestGeofencesNotCompleted ? <Badge color='danger'>Incompleto</Badge> : <Badge color='success'>Completo</Badge>,
			minWidth:'300px'
		},
		{
			id: 'geofences',
			name: 'Geocercas no identificadas',
			center: true,
			selector: row => row?.latestGeofencesNotCompleted,
		},
	];
	return columns;
}

export default Columns;